// src/data/blogPosts.js

export const CATEGORIES = [
  "All",
  "Business Setup",
  "UAE Visa",
  "Free Zone",
  "Mainland",
  "Corporate Tax",
  "VAT",
  "Banking",
  "PRO Services",
  "Golden Visa",
  "Food Business Setup" // New Category
];

export const blogPosts = [
  // EXISTING POSTS
  {
    title: "How to set up a business in Dubai 2026",
    slug: "how-to-set-up-a-business-in-dubai-2026",
    excerpt: "Everything you need to know about the latest DED regulations, visa updates, and steps to successfully launch your business in Dubai this year.",
    img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1200&q=80",
    category: "Business Setup",
    date: "May 12, 2026",
    readTime: "8 min",
    author: "BizWize Experts",
    featured: true
  },
  {
    title: "Navigating the New UAE Visa Options",
    slug: "navigating-new-uae-visa-options",
    excerpt: "A comprehensive breakdown of the Green Visa, freelance permits, and residency rules introduced recently for foreign nationals.",
    img: "https://images.unsplash.com/photo-1544644181-1484b3fdfc62?auto=format&fit=crop&w=800&q=80",
    category: "UAE Visa",
    date: "May 10, 2026",
    readTime: "6 min",
    author: "Visa Dept"
  },
  {
    title: "Top 5 Free Zones for Tech Startups",
    slug: "top-5-free-zones-tech-startups",
    excerpt: "Discover the best free zones in the UAE offering 100% foreign ownership, zero taxes, and robust tech infrastructure to scale your startup.",
    img: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80",
    category: "Free Zone",
    date: "May 08, 2026",
    readTime: "5 min",
    author: "BizWize Experts"
  },
  {
    title: "Mainland vs Free Zone: Which is better?",
    slug: "mainland-vs-free-zone",
    excerpt: "The ultimate comparison. Find out which jurisdiction suits your business model, budget, and long-term expansion plans.",
    img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
    category: "Mainland",
    date: "May 05, 2026",
    readTime: "9 min",
    author: "BizWize Experts"
  },
  {
    title: "Top UAE Corporate Tax Laws You Should Know",
    slug: "top-uae-business-laws",
    excerpt: "Stay compliant and avoid penalties. A deep dive into the recent Corporate Tax updates, Emiratization laws, and labor regulations.",
    img: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?auto=format&fit=crop&w=800&q=80",
    category: "Corporate Tax",
    date: "May 02, 2026",
    readTime: "7 min",
    author: "Legal Team"
  },
  {
    title: "Understanding VAT Compliance in the UAE",
    slug: "understanding-vat-compliance-uae",
    excerpt: "Essential guidelines for small and medium businesses to maintain accurate records and ensure timely VAT return filings.",
    img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=800&q=80",
    category: "VAT",
    date: "Apr 28, 2026",
    readTime: "5 min",
    author: "Finance Team"
  },
  {
    title: "Corporate Banking in the UAE: What You Need",
    slug: "corporate-banking-in-uae",
    excerpt: "Opening a corporate bank account in Dubai can be tricky. Learn what documents are required and how to fast-track your application.",
    img: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?auto=format&fit=crop&w=800&q=80",
    category: "Banking",
    date: "Apr 24, 2026",
    readTime: "4 min",
    author: "Finance Team"
  },
  {
    title: "Why You Need Professional PRO Services",
    slug: "why-you-need-professional-pro-services",
    excerpt: "Outsourcing PRO services can save your business time and money. Here’s how experts handle government approvals seamlessly.",
    img: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=800&q=80",
    category: "PRO Services",
    date: "Apr 20, 2026",
    readTime: "6 min",
    author: "Operations Dept"
  },
  {
    title: "A Guide to the UAE Golden Visa",
    slug: "guide-to-uae-golden-visa",
    excerpt: "How entrepreneurs, investors, and specialized talents can secure a 10-year residency in the UAE. Check your eligibility today.",
    img: "https://images.unsplash.com/photo-1558222218-b7b54eede3f3?auto=format&fit=crop&w=800&q=80",
    category: "Golden Visa",
    date: "Apr 15, 2026",
    readTime: "7 min",
    author: "Visa Dept"
  },

  // NEW FOOD BUSINESS SETUP POSTS
  {
    title: "Restaurant Business Setup in UAE",
    slug: "restaurant-business-setup-uae",
    excerpt: "A complete 2026 guide on acquiring a restaurant license, DED approvals, and finding the perfect location for your F&B concept.",
    img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 14, 2026",
    readTime: "10 min",
    author: "F&B Specialists"
  },
  {
    title: "Cafeteria License in Dubai",
    slug: "cafeteria-license-dubai",
    excerpt: "Step-by-step instructions on securing a cafeteria license, municipality approvals, and cost breakdowns in Dubai.",
    img: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 13, 2026",
    readTime: "6 min",
    author: "F&B Specialists"
  },
  {
    title: "How to Start a Cloud Kitchen in the UAE",
    slug: "cloud-kitchen-setup-uae",
    excerpt: "Capitalize on the food delivery boom. Learn the legal and operational requirements for setting up a highly profitable cloud kitchen.",
    img: "https://images.unsplash.com/photo-1587314168485-3236d6710814?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 12, 2026",
    readTime: "8 min",
    author: "F&B Specialists"
  },
  {
    title: "Getting a Food Truck License in the UAE",
    slug: "food-truck-license-uae",
    excerpt: "From RTA approvals to food safety standards, here is your roadmap to launching a successful food truck business.",
    img: "https://images.unsplash.com/photo-1565123409695-7b5ef63a2efb?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 11, 2026",
    readTime: "7 min",
    author: "F&B Specialists"
  },
  {
    title: "Bakery Business Setup Guide",
    slug: "bakery-business-setup-uae",
    excerpt: "Essential insights on industrial vs retail bakery licenses, central kitchen setups, and Dubai Municipality food control.",
    img: "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 10, 2026",
    readTime: "6 min",
    author: "F&B Specialists"
  },
  {
    title: "Cafe Business License Dubai",
    slug: "cafe-business-license-dubai",
    excerpt: "Learn how to open a specialty coffee shop, secure your DED license, and pass the required health and safety inspections.",
    img: "https://images.unsplash.com/photo-1497935586351-b67a49e012bf?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 09, 2026",
    readTime: "8 min",
    author: "F&B Specialists"
  },
  {
    title: "Food Delivery Business Setup",
    slug: "food-delivery-business-setup",
    excerpt: "Starting an aggregator or localized food delivery service? Discover the app-based licensing structures in mainland and free zones.",
    img: "https://images.unsplash.com/photo-1526367790999-0150786686a2?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 08, 2026",
    readTime: "7 min",
    author: "F&B Specialists"
  },
  {
    title: "Home Food Business License UAE",
    slug: "home-food-business-license-uae",
    excerpt: "Everything you need to know about the Intelaq license and selling homemade food legally in the UAE.",
    img: "https://images.unsplash.com/photo-1556910103-1c02745a8728?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 07, 2026",
    readTime: "5 min",
    author: "F&B Specialists"
  },
  {
    title: "Actual Restaurant Cost in Dubai",
    slug: "restaurant-cost-in-dubai",
    excerpt: "A realistic breakdown of licensing, rent, fit-out, and operational costs for launching a mid-tier restaurant in Dubai.",
    img: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 06, 2026",
    readTime: "9 min",
    author: "Finance Team"
  },
  {
    title: "Navigating Food Safety Approvals in UAE",
    slug: "food-safety-approvals-uae",
    excerpt: "Demystifying the Food Control Department's regulations. How to ensure your kitchen meets strict UAE safety standards.",
    img: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 05, 2026",
    readTime: "7 min",
    author: "Operations Dept"
  },
  {
    title: "Municipality Approvals for F&B",
    slug: "municipality-approvals",
    excerpt: "A guide to navigating Dubai Municipality's layout approvals, drainage requirements, and initial F&B inspections.",
    img: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 04, 2026",
    readTime: "6 min",
    author: "Operations Dept"
  },
  {
    title: "HACCP Requirements in the UAE",
    slug: "haccp-requirements-uae",
    excerpt: "Why HACCP certification is critical for large-scale F&B operations, catering companies, and food manufacturers.",
    img: "https://images.unsplash.com/photo-1584472282996-aca925fa43f8?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 03, 2026",
    readTime: "7 min",
    author: "Legal Team"
  },
  {
    title: "Central Kitchen Setup: What You Need to Know",
    slug: "central-kitchen-setup",
    excerpt: "Scaling your restaurant empire? Here is how to legally set up a centralized production kitchen to supply multiple outlets.",
    img: "https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 02, 2026",
    readTime: "8 min",
    author: "F&B Specialists"
  },
  {
    title: "How to Get a Food Import License in UAE",
    slug: "food-import-license-uae",
    excerpt: "Importing ingredients or FMCG products? A guide to ZADI, Dubai Customs, and food label registration processes.",
    img: "https://images.unsplash.com/photo-1586528116311-ad8ed7c80a30?auto=format&fit=crop&w=800&q=80",
    category: "Food Business Setup",
    date: "May 01, 2026",
    readTime: "6 min",
    author: "Logistics Experts"
  }
];
